var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitAndLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3363 0.304709C13.6385 0.254091 13.9041 0.324403 14.1332 0.515646C14.4457 0.796897 14.7582 1.07815 15.0707 1.3594C12.5881 4.20144 10.0881 7.02958 7.57072 9.84377C6.91447 9.87504 6.25822 9.87504 5.60197 9.84377C5.48867 9.72757 5.4418 9.58694 5.46135 9.4219C5.44278 9.23266 5.49749 9.0686 5.62541 8.92971C8.03164 6.21096 10.4379 3.49221 12.8442 0.773459C13.0033 0.606345 13.1674 0.450093 13.3363 0.304709Z",
    fill: "#304FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.841,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4922 1.80469C15.6253 1.84797 15.7347 1.9261 15.8203 2.03906C13.5147 4.63367 11.2178 7.23525 8.92969 9.84375C8.75573 9.88242 8.58384 9.87464 8.41406 9.82031C10.7628 7.13817 13.1221 4.46628 15.4922 1.80469Z",
    fill: "#304FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2422 2.46094C17.1439 3.19819 18.0268 3.96382 18.8906 4.75781C19.0019 4.96378 19.0332 5.1825 18.9844 5.41406C17.7229 6.91256 16.4339 8.38912 15.1172 9.84375C13.3203 9.87502 11.5234 9.87502 9.72656 9.84375C11.9082 7.38886 14.0801 4.92792 16.2422 2.46094ZM16.8516 4.19531C16.9992 4.18178 17.1398 4.20522 17.2734 4.26562C17.4609 4.42187 17.6484 4.57813 17.8359 4.73438C18.2103 5.09133 18.2025 5.44289 17.8125 5.78906C17.3376 6.34219 16.8454 6.88125 16.3359 7.40625C16.1237 7.50891 15.9206 7.49325 15.7266 7.35938C15.4859 7.16564 15.2593 6.9547 15.0469 6.72656C14.9774 6.57647 14.9617 6.42019 15 6.25781C15.5628 5.51564 16.18 4.82812 16.8516 4.19531Z",
    fill: "#304FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.872,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9922 4.85156C17.1682 4.95694 17.3244 5.08973 17.4609 5.25C16.9995 5.78161 16.5308 6.30506 16.0547 6.82031C15.907 6.69609 15.7664 6.56325 15.6328 6.42188C16.0958 5.90442 16.5489 5.38102 16.9922 4.85156Z",
    fill: "#304FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.949,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58594 7.99217C4.25854 7.97656 4.93041 7.99222 5.60156 8.03905C5.36611 8.3135 5.13956 8.59475 4.92187 8.8828C4.85686 9.05694 4.81781 9.23661 4.80469 9.42186C4.84528 9.63589 4.88433 9.84683 4.92187 10.0547C4.40528 10.2813 3.96778 10.6094 3.60937 11.039C3.58594 10.0235 3.57813 9.00791 3.58594 7.99217Z",
    fill: "#304FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5547 7.99217C18.5243 7.85947 19.3289 8.15633 19.9688 8.8828C20.1607 9.1693 20.2935 9.48181 20.3672 9.8203C18.8985 9.88278 17.4297 9.88278 15.9609 9.8203C16.4933 9.20998 17.0245 8.60061 17.5547 7.99217Z",
    fill: "#304FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55469 10.5234C10.4922 10.5234 15.4297 10.5234 20.3672 10.5234C20.3672 11.9453 20.3672 13.3672 20.3672 14.7891C19.1015 14.7812 17.8358 14.7891 16.5703 14.8125C15.3962 15.1194 14.7556 15.8772 14.6484 17.0859C14.7139 18.065 15.1827 18.776 16.0547 19.2188C16.3261 19.3257 16.6073 19.3882 16.8984 19.4062C18.0546 19.4297 19.2108 19.4375 20.3672 19.4297C20.375 20.0236 20.3672 20.6174 20.3438 21.2109C20.1013 22.3442 19.4372 23.1176 18.3516 23.5312C18.2123 23.5685 18.0717 23.5997 17.9297 23.625C13.1485 23.6484 8.36724 23.6563 3.58594 23.6484C3.57812 19.9297 3.58594 16.2109 3.60938 12.4922C3.86005 11.4368 4.50849 10.7806 5.55469 10.5234Z",
    fill: "#304FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7111 15.3984C17.9299 15.3984 19.1486 15.3984 20.3674 15.3984C20.3674 16.5234 20.3674 17.6484 20.3674 18.7734C19.1329 18.7813 17.8985 18.7734 16.6643 18.75C15.6384 18.457 15.193 17.7773 15.3283 16.7109C15.527 15.9886 15.988 15.5511 16.7111 15.3984Z",
    fill: "#304FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitAndLoss);
export default __webpack_public_path__ + "static/media/profitAndLoss.d4a6247e54635dbbca212574a30227d9.svg";
export { ForwardRef as ReactComponent };